import { render, staticRenderFns } from "./CustomerShow.vue?vue&type=template&id=ff7fb46a&scoped=true&"
import script from "./CustomerShow.vue?vue&type=script&lang=ts&"
export * from "./CustomerShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7fb46a",
  null
  
)

export default component.exports